import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const CurrencyManagerService = {};

// List User
CurrencyManagerService.listCurrencyManager = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/currencies?filter[record_status]=O`,
    method: "get",
    params: {
      ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // sort: params.sort || "-maker_date",
      // keywords: params.keywords || "",
      // expand: params.expand || "usprofile,checker",
    },
  });
};

// List User Role
CurrencyManagerService.listUserRole = ({ params }) => {
  return fetch({
    url: `${env.API_MSP}/users/default-roles`,
    method: "get",
    params: { ...params },
  });
};

// Create User
CurrencyManagerService.createCurrencyManager = ({ userCreate }) => {
  return fetch({
    url: `${env.API_MSP}/currencies`,
    method: "post",
    data: {
      ...userCreate,
    },
  });
};
// Update
CurrencyManagerService.updateCurrencyManager = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/currencies/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Detail User
CurrencyManagerService.detailCurrencyManager = function ({ userId, params }) {
  return fetch({
    url: `${env.API_MSP}/currencies/${userId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || "usprofile",
    },
  });
};

// Update User
CurrencyManagerService.updateUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete User
CurrencyManagerService.deleteCurrencyManager = ({ userId }) => {
  return fetch({
    url: `${env.API_MSP}/currencies/${userId.userId}`,
    method: "delete",
  });
};

// Active User
CurrencyManagerService.activeUser = ({ userId, data }) => {
  return fetch({
    url: `${env.API_MSP}/users/${userId}/restore`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default CurrencyManagerService;
